import React from 'react'
import TabView from '../components/TabView'

const ProcessTab = ({tab, data}) => <TabView tab={tab} data={data} byGroup/>

export default ProcessTab
